/**
 * 登录用户模块
 */
export const USER_SIGNIN = 'USER_SIGNIN'          		  				//用户登录
export const USER_SIGNOUT = 'USER_SIGNOUT'        		  				//用户退出
export const SET_TOKEN = 'SET_TOKEN'          		  				    //保存token
export const SET_USERNAME = 'SET_USERNAME'          		  		    //保存用户名
export const REMOVE_USERNAME = 'REMOVE_USERNAME'          		  		//删除用户名
export const SET_USERIMG = 'SET_USERIMG'          		  		        //保存用户头像
export const REMOVE_USERIMG = 'REMOVE_USERIMG'          		  		//删除用户头像
export const REMOVE_TOKEN = 'REMOVE_TOKEN'        		  				//删除token
export const SET_GROUP = 'SET_GROUP'          		  				    //保存group
export const REMOVE_GROUP = 'REMOVE_GROUP'        		  				//删除group
export const SET_ADMIN = 'SET_ADMIN'          		  				    //保存admin
export const REMOVE_ADMIN = 'REMOVE_ADMIN'        		  				//删除admin
export const SET_TOKENTIMER = 'SET_TOKENTIMER'        		  			//保存tokentimer
export const SET_ALL = 'SET_ALL'        		  						//保存全部登录信息
export const REMOVE_ALL = 'REMOVE_ALL'        		  				    //删除全部登录信息
export const SET_STATUS = 'SET_STATUS'        		  				    //设置返回状态
export const SAVE_LEVEL = 'SAVE_LEVEL'									//保存levv(2：保险公司、人保客服，3：救援公司)

export const GET_VERSION_NO = 'GET_VERSION_NO'							//获取版本号
export const SHOW_BACK_MISSION = 'SHOW_BACK_MISSION'					//展开后台任务
/**
 * 全局方法
 */
 
/**
 * 订单一览状态
 */
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS'          	    //设置订单一览状态

/**
 * 报警计划
 */
export const SET_ALARM_PLAN_TYPE = 'SET_ALARM_PLAN_TYPE'          	    //设置报警计划报警类型
export const SET_ALARM_TYPE = 'SET_ALARM_TYPE'          	  			//设置报警类型
export const SET_ALARM_LEVEL = 'SET_ALARM_LEVEL'          	  			//设置报警紧急度

/**
 * 字典数据
 */
export const ADD_DICTIONARY = 'ADD_DICTIONARY'          	  			//增加字典

/**
 * 布局
 */
export const THEME_CHANGE = 'THEME_CHANGE'          	  				//改变主题
export const FIXED_NAV = 'FIXED_NAV'        	  		  				//顶部固定
export const RIGHT_SIDEBAR = 'RIGHT_SIDEBAR'        	  				//右侧边栏开关
export const ALARM_RIGHT_SIDEBAR = 'ALARM_RIGHT_SIDEBAR'        	  	//报警右侧边栏开关

/**
 * 权限控制
 */
export const SET_PERMISSION = 'SET_PERMISSION'          	  			//保存权限
export const DEL_PERMISSION = 'DEL_PERMISSION'          	  			//删除权限

/**
 * 车辆监控-轨迹
 */
export const ADD_TRACE_VEHICLE = 'ADD_TRACE_VEHICLE'      				//增加轨迹车辆
export const DEL_CHOSEN = 'DEL_CHOSEN'
export const DEL_TRACE_VEHICLE = 'DEL_TRACE_VEHICLE'      				//删除轨迹车辆
export const CLEAR_TRACE_VEHICLE = 'CLEAR_TRACE_VEHICLE'  				//清空轨迹车辆
export const CHANGE_TRACE_VEHICLE = 'CHANGE_TRACE_VEHICLE'   	        //改变当前轨迹车辆

export const HIDE_LOADING = 'HIDE_LOADING'
export const LOAD_POSI = 'LOAD_POSI'
//共用
export const SHOW_MODAL = "SHOW_MODAL"									//显示弹框
export const HIDE_MODAL = "HIDE_MODAL"									//隐藏弹框
//日历有关
export const SHOW_CALENDAR = 'SHOW_CALENDAR'							//显示日历控件
export const HIDE_CALENDAR = 'HIDE_CALENDAR'							//隐藏日历控件
export const SET_TRACE_DAY = 'SET_TRACE_DAY'							//根据日历选中日期获取轨迹信息
export const GET_DEVICE_INFO = 'GET_DEVICE_INFO'						//获取轨迹车辆id和设备id
export const GET_NEW_MONTH_TRACE = 'GET_NEW_MONTH_TRACE'				//点击日历前后年份和月份=>获取切换后的月份中有轨迹的日期和当日总里程数
export const POST_NEW_DAY = 'POST_NEW_DAY'								//更新后台日期字段
//轨迹队列有关
export const GET_TRACELIST = 'GET_TRACELIST'							//获取轨迹队列	
export const PRE_NEXT_TRACKDATE = 'PRE_NEXT_TRACKDATE'					//获取前后有轨迹的日期
export const GET_CHECKED = 'GET_CHECKED'								//获取选中要被删除的车辆集合
export const REMOVE_CHECKED = 'REMOVE_CHECKED'							//反选选中要被删除的车辆集合
export const DEL_TRACELIST = 'DEL_TRACELIST'							//删除轨迹队列
export const DEL_ALL = 'DEL_ALL'
export const SET_CHECKBOX = 'SET_CHECKBOX'								//设置、改变、更新复选框选中状态
export const RE_CHECKBOX = 'RE_CHECKBOX'								//点击反选
export const UP_LOCKFLAG = 'UP_LOCKFLAG'								//更新锁定状态
export const ADD_LOCATE_POINT = 'ADD_LOCATE_POINT'						//追加队列-增加定位点
export const ADD_TRACK_LIST = 'ADD_TRACK_LIST'							//追加队列-增加单个车辆轨迹（新）
export const TRACK_ALL = 'TRACK_ALL'									//追加队列-从底部面板增加轨迹列表
export const ADD_TRACK_HISTORY = 'ADD_TRACK_HISTORY'					//追加队列-增加单个车辆轨迹（历史）
export const ADD_ALARM_LIVE = 'ADD_ALARM_LIVE'							//追加到轨迹队列-报警现场
//报警现场有关
export const GET_DAY_ALARMDATA = 'GET_DAY_ALARMDATA'					//获取某天的报警现场信息
//查看定位点有关
export const GET_PRE_NEXT_POINT = 'GET_PRE_NEXT_POINT'					//获取前后定位点
export const SET_VEHICLE_POSITION = 'SET_VEHICLE_POSITION'				//将车辆定位点显示到地图上

export const MOVE_FLAG = 'MOVE_FLAG'
export const INIT_MAP = 'INIT_MAP'
//轨迹回放有关
export const GET_DAY_TRACKDATA = 'GET_DAY_TRACKDATA'					//获取某天的轨迹数据
export const GET_DAY_TRAVELS = 'GET_DAY_TRAVELS'						//将某天的轨迹分段
export const GET_XAXIS_VALUE = 'GET_XAXIS_VALUE'						//获取时间轴移动对应的时刻
export const GET_MOMENT_TRACK = 'GET_MOMENT_TRACK'						//获取（时间轴）某一时刻对应轨迹信息
export const SAVE_ENDX = 'SAVE_ENDX'
export const SAVE_UNITX = 'SAVE_UNITX'
export const SAVE_STARTX = 'SAVE_STARTX'
export const GET_STOP_INDEX = 'GET_STOP_INDEX'							//保存停车时的索引
export const HAS_TRACK_X = 'HAS_TRACK_X'
export const CLEAR_BEFORE_DRAW = 'CLEAR_BEFORE_DRAW'
export const SET_DRAGGING = 'SET_DRAGGING'
export const SET_PLAYING = 'SET_PLAYING'

export const GET_RESCUE_TRACK = 'GET_RESCUE_TRACK'						//获取救援轨迹
/*
 * 监控平台
 * */
export const GET_QUEUE = 'GET_QUEUE'									//跟踪画面右侧队列数据

export const LOAD_TREE_LIST = 'LOAD_TREE_LIST'
export const LOADING_TAB_MAP = 'LOADING_TAB_MAP'
export const LOADING_CAR_TAB = 'LOADING_CAR_TAB' 
export const CHECKED_VEHICLE = 'CHECKED_VEHICLE'						//点击车辆checkbox
export const REMOVE_VEHICLE = 'REMOVE_VEHICLE'							//点击车辆一览的移出按钮
export const CLEAR_CHECKED = 'CLEAR_CHECKED'							//取消所有车辆选中状态

export const CHANGE_PANEL = 'CHANGE_PANEL'								//点击切换tabSelected面板
export const GO_LIST_PANEL = 'GO_LIST_PANEL'							//点击切换到车辆一览tab

export const CLEAR_ALL_LIST = 'CLEAR_ALL_LIST'							//清空监控平台底部车辆一览和关注面板信息
export const MAGNIFY_TREE = 'MAGNIFY_TREE'

export const INIT_MAP_TAB = 'INIT_MAP_TAB'								//初始化tabMap面板
export const ADD_MAP_TAB = 'ADD_MAP_TAB'								//点击增加tabMap面板
export const CHANGE_MAP_TAB = 'CHANGE_MAP_TAB'							//点击切换tabMap面板
export const GET_AREA_LIST = 'GET_AREA_LIST'							//获取围栏列表数据
export const DELETE_AREA = 'DELETE_AREA'								//删除围栏某条数据
export const ADD_TO_POINT = 'ADD_TO_POINT'								//将地址转成坐标点
export const REMOVE_MARKER = 'REMOVE_MARKER'
export const FENCE_TO_MAP = 'FENCE_TO_MAP'								//将坐标集合绘成多边形围栏
export const REMOVE_FENCE = 'REMOVE_FENCE'
export const ROUTE_TO_MAP = 'ROUTE_TO_MAP'								//将坐标集合绘成路线
export const REMOVE_ROUTE = 'REMOVE_ROUTE'
export const CLEAR_MAP = 'CLEAR_MAP'


export const GET_ROUTE_LIST = 'GET_ROUTE_LIST'							//获取路线列表数据
export const DELETE_ROUTE = 'DELETE_ROUTE'								//删除路线某条数据
export const GET_NOTE_LIST = 'GET_NOTE_LIST'							//获取标注列表数据
export const DELETE_NOTE = 'DELETE_NOTE'								//删除标注某条数据

export const SAVE_MOUNT_TIME = 'SAVE_MOUNT_TIME'						//保存初始化时间			
//删除弹框部分
export const SHOW_DEL_MODAL = 'SHOW_DEL_MODAL' 							//显示删除围栏或路线时的弹框
export const HIDE_DEL_MODAL = 'HIDE_DEL_MODAL' 							//隐藏删除围栏或路线时的弹框
//指令弹框部分
export const SHOW_INST_MODAL = "SHOW_INST_MODAL"						//显示发布指令时的弹框
export const HIDE_INST_MODAL = "HIDE_INST_MODAL"						//隐藏发布指令时的弹框
export const GET_CMD_INFO = "GET_CMD_INFO"								//获取指令信息
export const NEXT_CLICKABLE = 'NEXT_CLICKABLE'							//点击取消（取消-确定）
export const INS_ALL_DEVICE = "INS_ALL_DEVICE"							//全选
export const INS_OPP_DEVICE = "INS_OPP_DEVICE"							//反选
export const INS_REMOVE_ALL = "INS_REMOVE_ALL"							//全部取消、初始化
export const INS_CHECKED_DEVICE = 'INS_CHECKED_DEVICE'					//选中
export const INS_REMOVED_DEVICE = 'INS_REMOVED_DEVICE'					//取消选中
//关注弹框部分
export const SHOW_FOLLOW_MODAL = 'SHOW_FOLLOW_MODAL'					//显示关注车辆时的弹框
export const HIDE_FOLLOW_MODAL = 'HIDE_FOLLOW_MODAL' 					//隐藏关注车辆时的弹框
//底部一览部分
export const GET_VEHICLE_LIST = 'GET_VEHICLE_LIST'						//获取底部车辆一览列表
export const REFRESH_VEHICLE_LIST = 'REFRESH_VEHICLE_LIST'
export const SHOW_DEVICE_LIST = 'SHOW_DEVICE_LIST'						//显示车辆的设备一览
export const CLOSE_DEVICE_LIST = 'CLOSE_DEVICE_LIST'
//关注面板部分
export const OLD_FOLLOW_PANELS = 'OLD_FOLLOW_PANELS'					//获取原有关注面板
export const GET_FOLLOW_PANEL = 'GET_FOLLOW_PANEL'						//获取关注面板
export const GET_ALL_FOLLOW = 'GET_ALL_FOLLOW'							//初始化所有关注面板
export const REFRESH_FOLLOW_PANEL = 'REFRESH_FOLLOW_PANEL'				//刷新关注面板
//公共--提示弹框部分
export const HIDE_TIP_MODAL = 'HIDE_TIP_MODAL'							//隐藏提示弹框
export const SHOW_TIP_MODAL = 'SHOW_TIP_MODAL'							//显示提示弹框

export const GOT_BROWSER_POS = 'GOT_BROWSER_POS'						//获取到浏览器定位位置
export const ALL_TRACK_LIST = 'ALL_TRACK_LIST'							//追加到轨迹队列-分支
export const LOCATE_ONE = 'LOCATE_ONE'									//在地图上定位-单个车辆
export const LOCATE_ALL = 'LOCATE_ALL'									//在地图上定位-全部面板批量车
//右侧悬浮框
export const SHOW_ALARM_INFO = 'SHOW_ALARM_INFO'						//右侧悬浮框里-点击报警类型切换到对应报警详情
export const GET_ALARM_NUM = 'GET_ALARM_NUM'							//获取各报警类型各有的数量
export const CLOSE_ALARM_NUM = 'CLOSE_ALARM_NUM'						//取消轮巡获取报警数量
export const GET_ALARM_DETAIL = 'GET_ALARM_DETAIL'						//报警信息-处理按钮
export const CLOSE_ALARM_DETAIL = 'CLOSE_ALARM_DETAIL'					//关闭报警处理弹框
export const GET_INST_LIST = 'GET_INST_LIST'							//获取指令列表
export const POST_INST = 'POST_INST'									//发送指令
export const ADD_VEHICLE_DETAIL = 'ADD_VEHICLE_DETAIL'					//车辆详情信息

export const GET_TRACK_MAP = 'GET_TRACK_MAP'
export const SHOW_RAIL_MODAL = 'SHOW_RAIL_MODAL'
export const HIDE_RAIL_MODAL = 'HIDE_RAIL_MODAL'
export const NOT_LOAD_TO_MAP = 'NOT_LOAD_TO_MAP'

//人保救援
export const DATA_FROM_RESCUE = 'DATA_FROM_RESCUE'
export const REFRESH_RESCUE_LIST = 'REFRESH_RESCUE_LIST'

//common
export const OPEN_BY_TAB = 'OPEN_BY_TAB'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js